/**
 * @description message object to send WebRTC Call data to agent
 * @module com.inq.flash.client.data
 * @class ChatCommunicationWebCallMessage
 * @param chat {Object}
 * @param text {Sring}
 * @extends com.inq.flash.client.data.ChatCommunicationMessage
 * @constructor
 */
com.inq.flash.client.data.ChatCommunicationRichMessage = function (chat, text,updateUserName, data) {
	com.inq.flash.client.data.ChatCommunicationMessage.call(this, chat, text, updateUserName);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_DATA, data);
};

$hxClasses.extend(com.inq.flash.client.data.ChatCommunicationMessage, com.inq.flash.client.data.ChatCommunicationRichMessage,
	"com.inq.flash.client.data.ChatCommunicationRichMessage");

com.inq.flash.client.data.ChatCommunicationRichMessage.prototype.__class__ =
com.inq.flash.client.data.ChatCommunicationRichMessage;
